import { useState } from 'react';
import { Link } from 'react-router';
import { invalidateData, useMe } from '../../api.ts';
import type { ImportParseResponse, QsoSaveResult } from '../../../shared/types.ts';
import { AdifUpload, ImportPreview } from '../../components/ImportPreview.tsx';
import { Help, PageHeader, useDocumentTitle } from '../../components/ui.tsx';

export function ImportAdifPage() {
  useDocumentTitle('Massalisäys');
  const { data: me } = useMe();
  const [parsed, setParsed] = useState<{ result: ImportParseResponse; name: string } | null>(null);
  const [done, setDone] = useState<QsoSaveResult | null>(null);

  return (
    <div className="page">
      <PageHeader
        title="Massalisäys (ADIF)"
        sub="Lataa logiohjelmasi tai LoTW:n ADIF-vienti (.adi). Tiedostoa ei tallenneta palvelimelle – vain hyväksymäsi QSO:t."
        actions={<Help name="Massalisäys" />}
      />
      {done && (
        <div className="alert alert-ok" style={{ marginBottom: 16 }}>
          {done.added.toLocaleString('fi-FI')} uutta yhteyttä lisätty
          {done.saved > done.added && `, ${(done.saved - done.added).toLocaleString('fi-FI')} oli jo olemassa tai toistui tiedostossa (päivitetty)`}
          {done.rejected > 0 && `, ${done.rejected} hylätty`}.{' '}
          {me && <Link to={`/users/${encodeURIComponent(me.id)}/qsos`}>Näytä omat QSO:t →</Link>}
        </div>
      )}
      {!parsed ? (
        <div className="card stack">
          <AdifUpload
            onParsed={(result, name) => {
              setDone(null);
              setParsed({ result, name });
            }}
          />
          <p className="muted small" style={{ margin: 0 }}>
            Maa tunnistetaan ensisijaisesti ADIF:n DXCC-numerosta, sitten prefiksistä. Jos prefiksi kuuluu useammalle maalle tai maata ei
            tunnisteta, rivi merkitään tarkistettavaksi. Sama yhteys (kutsu, band, moodi, maa) päivittyy eikä tuplaannu, joten saman login voi
            ladata uudelleen.
          </p>
        </div>
      ) : (
        <div className="card">
          <ImportPreview
            initial={parsed.result.rows}
            fileName={parsed.name}
            target={`/users/${encodeURIComponent(me!.id)}/qsos`}
            onDone={(result) => {
              setDone(result);
              setParsed(null);
              invalidateData();
            }}
          />
          {parsed.result.skipped > 0 && (
            <p className="muted small">{parsed.result.skipped} tietuetta ohitettiin puuttuvan kutsun, päivän tai ajan vuoksi.</p>
          )}
          <button className="btn btn-ghost btn-sm" onClick={() => setParsed(null)}>
            ← Valitse toinen tiedosto
          </button>
        </div>
      )}
    </div>
  );
}
